<template>
  <div>
    <div class="steps" :step="$route.query.step">
      <div :class="{'step1':true,'active':$route.query.step === '1'}">
        <div class="step-text">
          {{ $t('reset.text.step1') }}
        </div>
      </div>
      <div :class="{'step2':true,'active':$route.query.step === '2'}">
        <div class="step-text">
          {{ $t('reset.text.step2') }}
        </div>
      </div>
    </div>
    <div v-if="$route.query.step === '1'" class="date-selector">
      <calendar v-model="reset.period" mode="period-selector" :disabled-periods="shared ? [] : getDisabledPeriods()" @change="onPeriodChanged" @month-changed="onMonthChanged" />
      <div class="btn-area">
        <button class="btn btn-next" :disabled="!reset || !reset.period || reset.period.length === 0" @click="setStep('2', $event)">
          {{ $t('reset.button.next') }}
        </button>
      </div>
    </div>
    <div v-if="$route.query.step === '2'" class="step2-area">
      <div class="basis-info basis-info-1">
        <div class="reset-info-row title-input">
          <div class="reset-info-label">
            {{ $t('reset.editor.nm') }}
          </div>
          <div class="reset-info-input">
            <input-control
              v-model="reset.nm"
              type="text"
              class="simple-design"
              :title="$t('reset.editor.nm')"
              :no-title="true"
              :placeholder="$t('reset.placeholder.reset_name')"
              :required="true"
              :tabindex="1"
              @keypress="onKeypressOnInput($event)"
            />
          </div>
        </div>
        <div class="clear" />
        <div class="selectors">
          <input-control
            v-model="reset.sexdstnCode"
            class="simple-design select-type"
            name="sex_distinction"
            type="select"
            :no-title="true"
            :title="$t('column.nm.sexdstn_code')"
            :placeholder="$t('column.nm.sexdstn_code')"
            :required="true"
            :options="sexdstnOptions"
            :tabindex="2"
            @keypress="onKeypressOnInput($event)"
          />
          <input-control
            v-model="reset.ageCode"
            class="simple-design select-type"
            :no-title="true"
            type="select"
            name="age_code"
            :title="$t('column.nm.age_code')"
            :placeholder="$t('column.nm.age_code')"
            :required="true"
            :options="ageOptions"
            :tabindex="3"
            @keypress="onKeypressOnInput($event)"
          />
          <input-control
            v-model="reset.reasonsForInputControl"
            type="multiselect"
            :no-title="true"
            :required="true"
            :title="$t('calculator.placeholder.reset_reason')"
            class="simple-design reset-reason-select select-type"
            :options="reasonOptions"
            :tabindex="4"
            @keypress="onKeypressOnInput($event)"
          />
        </div>
        <div class="clear" />
        <div class="alarm-area">
          <div :class="{'reset-alarm': true, 'morning': true, 'active': reset.mornNtcnFlag === 'Y'}">
            <div class="alarm-label">
              <input-control
                v-model="reset.mornNtcnFlag"
                type="checkbox"
                :title="$t('reset.text.morning') + ' ' + $t('reset.editor.alarm')"
                :is-switch="false"
                name="morning-alarm-time_flag"
                :tabindex="6"
              />
            </div>
            <input-control
              v-model="reset.mornNtcnTm"
              type="time"
              title="00:00"
              :no-title="true"
              name="morning-alarm-time"
              class="alarm-input"
              :disabled="reset.mornNtcnFlag !== 'Y'"
              :tabindex="5"
              @keypress="onKeypressOnInput($event)"
            />
          </div>
          <div :class="{'reset-alarm': true, 'noon': true, 'active': reset.noonNtcnFlag === 'Y'}">
            <div class="alarm-label">
              <input-control
                v-model="reset.noonNtcnFlag"
                type="checkbox"
                :title="$t('reset.text.noon') + ' ' + $t('reset.editor.alarm')"
                :is-switch="false"
                name="noon-alarm-time_flag"
                :tabindex="6"
              />
            </div>
            <input-control
              v-model="reset.noonNtcnTm"
              type="time"
              title="00:00"
              :no-title="true"
              name="noon-alarm-time"
              class="alarm-input"
              :disabled="reset.noonNtcnFlag !== 'Y'"
              :tabindex="6"
              @keypress="onKeypressOnInput($event)"
            />
          </div>
          <div :class="{'reset-alarm': true, 'night': true, 'active': reset.nightNtcnFlag === 'Y'}">
            <div class="alarm-label">
              <input-control
                v-model="reset.nightNtcnFlag"
                type="checkbox"
                :title="$t('reset.text.night') + ' ' + $t('reset.editor.alarm')"
                :is-switch="false"
                name="night-alarm-time_flag"
                :tabindex="6"
              />
            </div>
            <input-control
              v-model="reset.nightNtcnTm"
              type="time"
              title="00:00"
              :no-title="true"
              name="night-alarm-time"
              class="alarm-input"
              :disabled="reset.nightNtcnFlag !== 'Y'"
              :tabindex="7"
              @keypress="onKeypressOnInput($event)"
            />
          </div>
        </div>
      </div>
      <div class="basis-info basis-info-2">
        <div class="basis-info-title">
          <img class="reset-editor-icon person" src="/img/icons/ico_info_g.png" alt="Info">
          &nbsp;
          {{ $t('reset.editor.basis_info') }}
        </div>
        <div class="basis-info-2-container">
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.bdwgh') }}<span class="unit">(kg)</span>
              </div>
            </div>
            <div class="basis-info-begin">
              <input-control
                v-model="reset.bgnBdwgh"
                type="number"
                class="begin-number basis-info-number simple-design"
                :title="$t('reset.editor.begin')"
                placeholder=" "
                :tabindex="8"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
            <div class="basis-info-goal">
              <input-control
                v-model="reset.goalBdwgh"
                type="number"
                class="goal-number basis-info-number simple-design"
                :title=" $t('reset.editor.goal')"
                placeholder=" "
                :tabindex="9"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.bone_rate') }}<span class="unit">(kg)</span>
              </div>
            </div>
            <div class="basis-info-begin">
              <input-control
                v-model="reset.bgnBoneRate"
                type="number"
                class="begin-number basis-info-number simple-design"
                :title="$t('reset.editor.begin')"
                placeholder=" "
                :tabindex="10"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
            <div class="basis-info-goal">
              <input-control
                v-model="reset.goalBoneRate"
                type="number"
                class="goal-number basis-info-number simple-design"
                :title="$t('reset.editor.goal')"
                placeholder=" "
                :tabindex="11"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.body_fat') }}<span class="unit">(kg)</span>
              </div>
            </div>
            <div class="basis-info-begin">
              <input-control
                v-model="reset.bgnBodyFat"
                type="number"
                class="begin-number basis-info-number simple-design"
                :title="$t('reset.editor.begin')"
                placeholder=" "
                :tabindex="12"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
            <div class="basis-info-goal">
              <input-control
                v-model="reset.goalBodyFat"
                type="number"
                class="goal-number basis-info-number simple-design"
                :title="$t('reset.editor.goal')"
                placeholder=" "
                :tabindex="13"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.bmi') }}<span class="unit">(kg/m<sup>2</sup>)</span>
              </div>
            </div>
            <div class="basis-info-begin">
              <input-control
                v-model="reset.bgnBmi"
                type="number"
                class="begin-number basis-info-number simple-design"
                :title="$t('reset.editor.begin')"
                placeholder=" "
                :tabindex="14"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
            <div class="basis-info-goal">
              <input-control
                v-model="reset.goalBmi"
                type="number"
                class="goal-number basis-info-number simple-design"
                :title="$t('reset.editor.goal')"
                placeholder=" "
                :tabindex="15"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.body_fat_rate') }}<span class="unit">(%)</span>
              </div>
            </div>
            <div class="basis-info-begin">
              <input-control
                v-model="reset.bgnBodyFatRate"
                type="number"
                class="begin-number basis-info-number simple-design"
                :title="$t('reset.editor.begin')"
                placeholder=" "
                :tabindex="16"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
            <div class="basis-info-goal">
              <input-control
                v-model="reset.goalBodyFatRate"
                type="number"
                class="goal-number basis-info-number simple-design"
                :title="$t('reset.editor.goal')"
                placeholder=" "
                :tabindex="17"
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
                @keypress="onKeypressOnInput($event)"
              />
            </div>
          </div>
        </div>
        <div class="basis-info-row inbody-image-row">
          <div class="basis-info-label-container">
            <div class="basis-info-title">
              <img class="reset-editor-icon inbody" src="/img/icons/ic_inbody.png" alt="Info">
              &nbsp;
              {{ $t('reset.editor.inbody_image') }}
            </div>
          </div>
          <div class="basis-info-controls basis-info-images-controls inbody-image-control">
            <div class="basis-info-control">
              <input-control
                id="inbody-image-file"
                v-model="reset.beginInbodyImages"
                type="singlefile"
                :show-image-view="true"
                custom-click-event="show-inbody-image"
                :no-title="true"
                :no-control-area="true"
                title=" "
                table-name="reset"
                :file-info="{purpose: 'file_purpose.begin_inbody',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
                @custom-click-event="onCustomClickEvent"
                @changed="onInbodyImageChanged"
              />
              <div v-if="inbodyImage && showInbodyImage" class="inbody-image" @click="toggleInbodyImage">
                <centered-image :src="getImgUrl(inbodyImage)" />
              </div>
            </div>
            <div class="btn-inbody-upload" @click="uploadInbodyImage($event)">
              +
            </div>
          </div>
        </div>
        <div :class="{'inbody-result-row': true, 'has-contents': ocrResult}" v-html="ocrResult" />
        <div class="begin-image-row">
          <div class="begin-image-title">
            <div class="dot" />
            <div class="basis-info-label">
              {{ $t('reset.editor.begin_photo') }}
              <span class="show-sample" @click="toggleSampleImage($event)">
                {{ $t('reset.editor.sample_image') }}
              </span>
              <div v-if="showSample" class="sample-image" @click="toggleSampleImage($event)">
                <img src="/img/reset/sample.png" alt="Sample">
              </div>
            </div>
          </div>
          <div class="basis-info-controls basis-info-images-controls begin-images-controls">
            <div id="begin-front-image-area" class="basis-info-control">
              <input-control
                v-model="reset.beginFrontImages"
                type="singlefile"
                :no-title="true"
                title=" "
                table-name="reset"
                :file-info="{purpose: 'file_purpose.begin_front',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
                :tabindex="18"
                @keypress="onKeypressOnInput($event)"
              />
              <div class="basis-info-control-name-and-button">
                <div class="basis-info-control-name">
                  {{ $t('reset.editor.front_image') }}
                </div>
                <div class="upload-btn" @click="uploadImageClick('#begin-front-image-area', $event)">
                  {{ $t('button.text.upload') }}
                </div>
              </div>
            </div>
            <div id="begin-side-image-area" class="basis-info-control">
              <input-control
                v-model="reset.beginSideImages"
                type="singlefile"
                :no-title="true"
                title=" "
                table-name="reset"
                :file-info="{purpose: 'file_purpose.begin_side',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
                :tabindex="19"
                @keypress="onKeypressOnInput($event)"
              />
              <div class="basis-info-control-name-and-button">
                <div class="basis-info-control-name">
                  {{ $t('reset.editor.side_image') }}
                </div>
                <div class="upload-btn" @click="uploadImageClick('#begin-side-image-area', $event)">
                  {{ $t('button.text.upload') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$route.query.mode==='transfer'" class="basis-info-row basis-info-row-search-partner">
          <div class="basis-info-title">
            <div class="dot" />
            &nbsp;
            {{ $t('reset.editor.search_partner') }}
          </div>
          <input
            v-model="selectedPartnerNm"
            :readonly="true"
            type="text"
            class="partner-search-keyword"
            :placeholder="$t('column.nm.nm') + ' - ' + $t('column.nm.user_id')"
            :tabindex="20"
            @click="showSearchPartnerModal($event)"
            @keypress="onKeypressOnInput($event)"
          >
          <button class="btn no-border partner-search-button hidden" @click="showSearchPartnerModal($event)">
            {{ $t('common.button.search') }}
          </button>
        </div>
      </div>
      <div class="controls detail-schedule-controls bottom-fixed-controls">
        <div class="button-area">
          <button class="btn no-border" @click="goBackStep($event)">
            {{ $t('common.button.prev') }}
          </button>
        </div>
        <div class="button-area">
          <button class="btn no-border" @click="completeConfirm($event)">
            {{ $t('reset.button.complete') }}
          </button>
        </div>
      </div>
    </div>
    <b-modal
      id="save-confirm-modal"
      ref="saveConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      modal-class="simple-design"
      :lazy="true"
      centered
      :no-close-on-backdrop="true"
      @ok="complete($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.save_confirm')" />
    </b-modal>
    <b-modal
      id="search-partner-modal"
      ref="searchPartnerModalRef"
      :title="$t('reset.modal.transfer_reset')"
      modal-class="simple-design full-modal"
      hide-footer
      :lazy="true"
      centered
      :no-close-on-backdrop="true"
    >
      <div class="search-control-container">
        <input v-model="searchPartnerKeyword" type="text" class="partner-search-keyword full" :placeholder="$t('column.nm.nm') + ' - ' + $t('column.nm.user_id')" @keyup="onKeyupUserKeyword($event)">
        <button class="btn no-border partner-search-button" @click="searchPartner($event)">
          {{ $t('common.button.search') }}
        </button>
      </div>
      <div v-if="searchedPartners && searchedPartners.length > 0" class="searched-partner-list-container" @scroll="onScrollSearchedPartnerList">
        <div class="searched-partner-list-wrapper">
          <div v-for="(partner, partnerIndex) in searchedPartners" :key="'searched-partner-' + partnerIndex" class="partner-item">
            <div class="partner-image">
              <centered-image :cover="true" :src="getImgUrl(partner.data.thumbs)" :alt="partner.data.nm" />
            </div>
            <div v-if="partner.data.nm" class="partner-name">
              {{ partner.data.nm }}
            </div>
            <div class="partner-name">
              {{ partner.data.userId }}
            </div>
            <div v-if="partner.data.usanaGradCode" class="partner-grade">
              {{ $t('code.nm.' + partner.data.usanaGradCode) }}
            </div>
            <div v-if="partner.data.mobile" class="partner-tel">
              {{ partner.data.mobile | formatKoreanTel(true) }}
            </div>
            <button class="btn btn-select-partner" @click="selectPartner(partner.data, $event)">
              {{ $t('common.button.ok') }}
            </button>
          </div>
          <div v-if="!searchedFriendsNoMore" class="reset-friends-loading resets-loading">
            <div class="clear" />
            <img src="/img/ajax-loader-white-bg.gif" alt="Loading">
            <strong>{{ $t('common.text.loading') }}</strong>
          </div>
        </div>
      </div>
      <div v-else class="searched-partner-list-container no-data">
        {{ $t('common.text.no_data') }}
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    shared: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      showSample: false,
      reset: undefined,
      selectedSchedule: undefined,
      scheduleTimeTab: 'morning',
      sexdstnCodes: [],
      resetReasonCodes: [],
      reasonOptions: [],
      sexdstnOptions: [],
      ageOptions: [],
      ageCodes: [],
      selectedPartner: undefined,
      selectedPartnerNm: undefined,
      searchPartnerKeyword: '',
      ocrResult: '',
      searchedPartners: [],
      resets: [],
      inbodyImage: undefined,
      showInbodyImage: false
    }
  },
  watch: {
    selectedPartner: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal.nm) {
            this.selectedPartnerNm = newVal.nm + ' - ' + newVal.userId
          } else {
            this.selectedPartnerNm = newVal.userId
          }
        } else {
          this.selectedPartnerNm = ''
        }
      },
      immediate: true,
      deep: true
    },
    reset: {
      handler(newVal, oldVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
        this.$forceUpdate()
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(newVal, oldVal) {
        this.reset = newVal
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    if (!window._processingDataCount) {
      window._processingDataCount = 0
    }
    window._processingDataCount++
    this.reset = this.value
    if (this.reset.bgnde && this.reset.endde) {
      this.reset.period = [
        {
          bgnde: this.reset.bgnde,
          endde: this.reset.endde
        }
      ]
    }

    this.ageCodes = await this.getCodes('age')
    this.ageOptions.push({
      value: '',
      text: this.$t('calculator.placeholder.age')
    })
    for (let i = 0; i < this.ageCodes.length; i++) {
      const code = this.ageCodes[i]
      this.ageOptions.push({
        value: code.codeId,
        text: this.$t('code.nm.' + code.codeId)
      })
    }
    this.sexdstnCodes = await this.getCodes('sex_distinction')
    this.sexdstnOptions.push({
      value: '',
      text: this.$t('calculator.placeholder.sex_distinction')
    })
    for (let i = 0; i < this.sexdstnCodes.length; i++) {
      const code = this.sexdstnCodes[i]
      this.sexdstnOptions.push({
        value: code.codeId,
        text: this.$t('code.nm.' + code.codeId)
      })
    }
    this.resetReasonCodes = await this.getCodes('reset_reason')
    for (let i = 0; i < this.resetReasonCodes.length; i++) {
      const code = this.resetReasonCodes[i]
      this.reasonOptions.push({
        value: code.codeId,
        text: this.$t('code.nm.' + code.codeId)
      })
    }
    if (!this.reset.sexdstnCode) {
      this.reset.sexdstnCode = ''
    }
    if (!this.reset.ageCode) {
      this.reset.ageCode = ''
    }
    if (!this.reset.mornNtcnTm) {
      this.reset.mornNtcnTm = '07:00'
    }
    if (!this.reset.noonNtcnTm) {
      this.reset.noonNtcnTm = '12:00'
    }
    if (!this.reset.nightNtcnTm) {
      this.reset.nightNtcnTm = '18:00'
    }
    if (!this.reset.bgnBdwgh) {
      this.reset.bgnBdwgh = 0
    }
    if (!this.reset.goalBdwgh) {
      this.reset.goalBdwgh = 0
    }
    if (!this.reset.bgnBmi) {
      this.reset.bgnBmi = 0
    }
    if (!this.reset.goalBmi) {
      this.reset.goalBmi = 0
    }
    if (!this.reset.bgnBoneRate) {
      this.reset.bgnBoneRate = 0
    }
    if (!this.reset.goalBoneRate) {
      this.reset.goalBoneRate = 0
    }
    if (!this.reset.bgnBodyFatRate) {
      this.reset.bgnBodyFatRate = 0
    }
    if (!this.reset.goalBodyFatRate) {
      this.reset.goalBodyFatRate = 0
    }
    if (!this.reset.bgnBodyFat) {
      this.reset.bgnBodyFat = 0
    }
    if (!this.reset.goalBodyFat) {
      this.reset.goalBodyFat = 0
    }
  },
  beforeDestroy() {
    if (this.searchUserTimer) {
      clearTimeout(this.searchUserTimer)
    }
  },
  methods: {
    toggleSampleImage(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showSample = !this.showSample
      this.$forceUpdate()
    },
    onCustomClickEvent(e) {
      this.inbodyImage = e.file
      this.showInbodyImage = !this.showInbodyImage
      this.$forceUpdate()
    },
    toggleInbodyImage(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showInbodyImage = !this.showInbodyImage
      this.$forceUpdate()
    },
    getDisabledPeriods() {
      const periods = []
      if (this.resets) {
        for (let i = 0; i < this.resets.length; i++) {
          const reset = this.resets[i]
          if (
            this.reset &&
            this.$route.query.mode === 'update' &&
            reset.id === this.reset.id
          ) {
            continue
          }
          periods.push({
            bgnde: reset.bgnde,
            endde: reset.endde
          })
        }
      }
      return periods
    },
    onPeriodChanged(param) {
      this.reset.period = param
      this.$forceUpdate()
    },
    onMonthChanged(param) {
      let beginDt = param.year + '/'
      if (param.month + 1 < 10) {
        beginDt += '0'
      }
      beginDt = beginDt + (param.month + 1) + '/01'

      if (!this.resetListRequestId) {
        this.resetListRequestId = 0
      }
      this.resetListRequestId++
      const endTime = new Date()
      endTime.setFullYear(param.year)
      endTime.setMonth(
        this.resetListRequestId === 1 ? param.month + 2 : param.month + 1
      )
      endTime.setDate(0)

      let endDt = endTime.getFullYear() + '/'
      if (endTime.getMonth() + 1 < 10) {
        endDt += '0'
      }
      endDt = endDt + (endTime.getMonth() + 1) + '/31'

      const url =
        '/reset/myresets?currentOnlyFlag=N&beginDt=' +
        encodeURIComponent(beginDt) +
        '&endDt=' +
        encodeURIComponent(endDt)
      this.$axios.$get(url).then(response => {
        if (response.resultCode === 'success') {
          if (response.data) {
            this.resets = response.data
          } else {
            this.resets = []
          }
          this.$forceUpdate()
        }
      })
    },
    selectPartner(partner, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.selectedPartner = partner
      this.$forceUpdate()
      this.hideModal('searchPartnerModalRef')
    },
    onKeyupUserKeyword(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
        this.vibrate(e)
      }
      if (e.target.value !== undefined) {
        this.searchPartnerKeyword = e.target.value
      }
      if (this.searchUserTimer) {
        clearTimeout(this.searchUserTimer)
      }
      this.searchUserTimer = setTimeout(() => {
        if (this.searchUserTimer) {
          clearTimeout(this.searchUserTimer)
          this.searchUserTimer = undefined
        }
        this.searchPartner(e)
      }, 300)
    },
    searchPartner(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.searchedPageNo = 0
      this.searchedFriendsNoMore = false
      this.searchPartnerProcess(true)
    },
    searchPartnerProcess(refresh) {
      this.searching = true
      const size = 15
      this.$axios
        .$get(
          '/reset/searchUsers?q=' +
            encodeURIComponent(this.searchPartnerKeyword) +
            '&withImageFlag=Y&withMeFlag=N&onlyMyPartner=Y&siteId=homepage&pageNo=' +
            this.searchedPageNo +
            '&size=' +
            size
        )
        .then(response => {
          this.searching = false
          if (response.resultCode === 'success') {
            this.searchedPageNo++
            if (refresh) {
              this.searchedPartners = []
            }
            this.searchedPartners = this.searchedPartners.concat(response.data)
            if (!response.data || response.data.length !== size) {
              this.searchedFriendsNoMore = true
            }
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
        .catch(e => {
          this.searching = false
        })
    },
    showSearchPartnerModal(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
        this.vibrate(e)
      }
      this.searchedPageNo = 0
      this.searchedPartners = []
      this.searchedFriendsNoMore = false
      this.searchPartnerKeyword = ''
      this.$forceUpdate()
      this.showModal('searchPartnerModalRef')
      this.searchPartner(e)
    },
    onInbodyImageChanged(e) {
      let file
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        file = e.target.files[0]
      }
      this.recognize(file, numbers => {
        if (numbers && numbers.length > 0) {
          for (let i = numbers.length - 1; i >= 0; i--) {
            if (isNaN(numbers[i])) {
              numbers.splice(i, 1)
            }
          }
          if (numbers.length > 0) {
            this.reset.bgnBdwgh = parseFloat(numbers[0])
          }
          if (numbers.length > 1) {
            this.reset.bgnBoneRate = parseFloat(numbers[1])
          }
          if (numbers.length > 2) {
            this.reset.bgnBodyFat = parseFloat(numbers[2])
          }
          if (numbers.length > 3) {
            this.reset.bgnBmi = parseFloat(numbers[3])
          }
          if (numbers.length > 4) {
            this.reset.bgnBodyFatRate = parseFloat(numbers[4])
          }
          this.$forceUpdate()
        }
      })
    },
    uploadInbodyImage(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      $('#inbody-image-file input[type=file]')
        .get(0)
        .click(e)
    },
    uploadImageClick(selector, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      $(selector + ' input[type=file]')
        .get(0)
        .click(e)
    },
    onChangedScheduleInTake(sched, time, de) {
      for (let i = 0; i < this.reset.schedules.length; i++) {
        const schedule = this.reset.schedules[i]
        if (schedule.de > de) {
          for (let j = 0; j < schedule[time].length; j++) {
            const sched2 = schedule[time][j]
            if (sched.product.id === sched2.product.id) {
              sched2.intakeCo = sched.intakeCo
            }
          }
        }
      }
      this.$forceUpdate()
    },
    async completeConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)

      if (
        !(await this.validateUnder(
          $(this.$el)
            .find('.step2-area')
            .get(0),
          'body'
        ))
      ) {
        return
      }
      if (this.$route.query.mode === 'transfer' && !this.selectedPartner) {
        this.$toast.error(this.$t('reset.notification.partner_required'))
        return
      }
      if (this.$route.query.mode !== 'transfer') {
        this.selectedPartner = undefined
      }
      this.showModal('saveConfirmModalRef')
    },
    complete(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)

      const dateFormat = this.$t('common.format.date')
      const bgnde = this.$moment(this.reset.bgnde, dateFormat)
        .toDate()
        .getTime()
      const endde = this.$moment(this.reset.endde, dateFormat)
        .toDate()
        .getTime()
      this.reset.schedules = []
      for (let de = bgnde; de <= endde; de += 24 * 60 * 60 * 1000) {
        const deStr = this.$moment(de).format(dateFormat)
        let foundSchedule
        for (let i = 0; i < this.reset.schedules.length; i++) {
          if (deStr === this.reset.schedules[i].de) {
            foundSchedule = this.reset.schedules[i]
          }
        }
        if (!foundSchedule) {
          foundSchedule = {
            de: deStr
          }
          this.reset.schedules.push(foundSchedule)
        }
        foundSchedule = this.updateSchedule(foundSchedule)
      }
      const reset = window.copyObject(this.reset)
      if (this.selectedPartner) {
        reset.selectedPartnerId = this.selectedPartner.id
      }
      this.$axios.$post('/reset/save', reset).then(response => {
        if (response.resultCode === 'success') {
          window._processingDataCount--
          this.hideModal('saveConfirmModalRef')
          this.$emit('saved')
          if (this.selectedPartner) {
            this.$toast.info(
              this.$t('reset.notification.transfered', {
                nm: this.selectedPartner.nm
                  ? this.selectedPartner.nm
                  : this.selectedPartner.userId
              })
            )
          } else {
            this.$toast.info(this.$t(response.message))
          }
          this.openLink('/reset_manager?submenu=reset_ing&mode=calendar')
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    onScrollSearchedPartnerList() {
      const comp =
        $('.searched-partner-list-wrapper').width() -
        $('.searched-partner-list-container').width()
      const left = $('.searched-partner-list-container').scrollLeft()
      if (comp - left < 100 && !this.searching) {
        this.searchPartnerProcess()
      }
    },
    goBackStep(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      history.go(-1)
    },
    setScheduleTimeTab(tab, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (this.scheduleTimeTab === tab) {
        return
      }
      this.vibrate(e)
      this.scheduleTimeTab = tab
      this.$forceUpdate()
    },
    onDaySelected(param) {
      this.selectedSchedule = undefined
      if (!this.reset.schedules || this.reset.schedules.length === 0) {
        return
      }
      if (!param.day) {
        return
      }

      const de = new Date(param.year, param.month, param.day)
      const deStr = this.$moment(de).format(this.$t('common.format.date'))
      for (let i = 0; i < this.reset.schedules.length; i++) {
        const schedule = this.reset.schedules[i]
        if (schedule.de === deStr) {
          this.selectedSchedule = schedule
          break
        }
      }
    },
    isInitialized() {
      if (!this.initiatedProductGroups || !this.updatedProductGroups) {
        return false
      }
      return window.isObjectEquals(
        this.initiatedProductGroups,
        this.updatedProductGroups
      )
    },
    toggleShowSelected(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showSelected = !this.showSelected
      this.$forceUpdate()
    },
    setStep(step, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (this.step === step) {
        return
      }
      const query = {}
      for (const key in this.$route.query) {
        query[key] = this.$route.query[key]
      }
      if (step === '2') {
        if (!this.reset.period) {
          const now = new Date()
          this.reset.period = [
            {
              bgnde: now,
              endde: now
            }
          ]
        }
        this.reset.bgnde = this.reset.period[0].bgnde
        this.reset.endde = this.reset.period[0].endde
        query.list_type = 'my_calc'
        query.substep = '1'
      }
      query.step = step

      if (step === '2') {
        if (!this.reset.mornNtcnFlag) {
          this.reset.mornNtcnFlag = 'Y'
        }
        if (!this.reset.noonNtcnFlag) {
          this.reset.noonNtcnFlag = 'Y'
        }
        if (!this.reset.nightNtcnFlag) {
          this.reset.nightNtcnFlag = 'Y'
        }
        /*
        if (this.isActivatedAlarm('morning')) {
          this.reset.mornNtcnFlag = 'Y'
        } else {
          this.reset.mornNtcnFlag = 'N'
        }
        if (this.isActivatedAlarm('noon')) {
          this.reset.noonNtcnFlag = 'Y'
        } else {
          this.reset.noonNtcnFlag = 'N'
        }
        if (this.isActivatedAlarm('night')) {
          this.reset.nightNtcnFlag = 'Y'
        } else {
          this.reset.nightNtcnFlag = 'N'
        } */
      }
      this.$router.push({
        query: query
      })
      this.vibrate(e)
      this.$forceUpdate()
    },
    onSelectReset(param) {
      this.products = param.reset.products
      this.setSubstep('2', param.e)
    },
    async onCalcSelected(param) {
      const id = param.calc.id
      const res = await this.$axios.$get('/calc/calc?id=' + id, {
        no_loading: true
      })
      this.products = []
      for (let i = 0; i < res.data.calcProducts.length; i++) {
        const calcProduct = res.data.calcProducts[i]
        this.products.push({
          id: calcProduct.prductId,
          co: calcProduct.co
        })
      }

      this.setSubstep('2', param.e)
    },
    setListType(type, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (type === 'direct_input') {
        this.products = this.reset.products
        this.setSubstep('2', e)
        return
      }
      const query = {}
      for (const key in this.$route.query) {
        query[key] = this.$route.query[key]
      }
      query.list_type = type
      this.$router.push({
        query: query
      })
      this.$forceUpdate()
    },
    setSubstep(substep, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (substep === '2') {
        this.scheduleTimeTab = 'morning'
      }
      this.vibrate(e)
      const query = {}
      for (const key in this.$route.query) {
        query[key] = this.$route.query[key]
      }
      query.substep = substep
      if (this.$route.query.mode === 'update' && substep === '1') {
        delete query.substep
        query.step = '1'
      }
      this.$router.push({
        query: query
      })
      this.$forceUpdate()
    },
    isActivatedAlarm(tmType) {
      if (!this.reset.schedules || this.reset.schedules.length === 0) {
        return false
      }
      for (let i = 0; i < this.reset.schedules.length; i++) {
        const products = this.reset.schedules[i][tmType]
        if (products && products.length > 0) {
          for (let j = 0; j < products.length; j++) {
            const product = products[j]
            if (product.intakeCo && parseInt(product.intakeCo) > 0) {
              return true
            }
          }
        }
      }
      return false
    },
    updateSchedule(sched) {
      if (!sched.morning) {
        if (this.reset.mornNtcnFlag === 'Y') {
          sched.morning = [{}]
        } else {
          sched.morning = []
        }
      }
      if (!sched.noon) {
        if (this.reset.noonNtcnFlag === 'Y') {
          sched.noon = [{}]
        } else {
          sched.noon = []
        }
      }
      if (!sched.night) {
        if (this.reset.nightNtcnFlag === 'Y') {
          sched.night = [{}]
        } else {
          sched.night = []
        }
      }
      return sched
    },
    initProductGroups(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.$refs.productGroupsRef.updateProductCounts()
    },
    onProductGroupsInitiated(param) {
      this.initiatedProductGroups = window.copyObject(param)
      this.$forceUpdate()
    },
    onProductGroupsUpdated(param) {
      this.updatedProductGroups = window.copyObject(param)
      const products = this.$refs.productGroupsRef.getSelectedProducts()
      if (!this.products) {
        this.products = []
      }
      if (products && products.length > 0) {
        for (let i = 0; i < products.length; i++) {
          const prod1 = products[i]
          let found = false
          for (let j = 0; j < this.products.length; j++) {
            const prod2 = this.products[j]
            if (prod1.id === prod2.id) {
              prod2.co = prod1.co
              found = true
              break
            }
          }
          if (!found) {
            this.products.push({
              id: prod1.id,
              co: prod1.co
            })
          }
        }
      }
      if (this.products && this.products.length > 0) {
        for (let i = this.products.length - 1; i >= 0; i--) {
          const prod1 = this.products[i]
          let found = false
          for (let j = 0; j < products.length; j++) {
            const prod2 = products[j]
            if (prod1.id === prod2.id) {
              found = true
              break
            }
          }
          if (!found) {
            this.products.splice(i, 1)
          }
        }
      }
      this.$forceUpdate()
    },
    getSelectedCount() {
      if (!this.updatedProductGroups) {
        return 0
      }
      let co = 0
      for (let i = 0; i < this.updatedProductGroups.length; i++) {
        const grp = this.updatedProductGroups[i]
        co += this.getSelectedCountInGroup(grp.data)
      }
      return co
    },
    getSelectedCountInGroup(data) {
      if (!data || data.length === 0) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < data.length; i++) {
        const datum = data[i]
        if (datum.co) {
          ret += datum.co
        }
      }
      return ret
    }
  }
}
</script>

<style scoped>
.active .step-right-arrow {
  width: 0;
  border-style: solid;
  border-width: 1.875rem 0 1.875rem 1.125rem;
  border-color: transparent transparent transparent #ededed;
}
.step-right-arrow {
  width: 1.125rem;
  height: 3.75rem;
}
.step-text {
  border-bottom: 1px solid #d8d8d8;
  height: 3.75rem;
  color: #d8d8d8;
}
.active .step-text {
  border-bottom: 2px solid #360ea6;
  height: 3.75rem;
  color: #360ea6;
  font-weight: bold;
}
.steps {
  position: fixed;
  z-index: 2;
  width: 100vw;
  height: 3.75rem;
  top: 14rem;
  display: flex;
  background: white;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  overflow: hidden;
}
.steps > div {
  width: calc(100vw / 2);
  display: flex;
  align-items: center;
  font-size: 0.95rem;
}
.steps > div.active {
  font-size: 1.05rem !important;
  color: #360ea6;
}
.step2 .step-text {
  width: 100%;
}
.step2 .step-right-arrow {
  border: none;
  width: 1.125rem;
}
.step-text {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.step2-area {
  padding-top: 4.3rem;
  margin-bottom: 3rem;
}
.basis-info {
  background: white;
  border-radius: 0.5rem;
  padding: 0;
  margin-bottom: 1rem;
}
.basis-info-2 {
  margin-bottom: 8rem;
}
.controls {
  position: fixed;
  left: 0;
  bottom: 4rem;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100vw;
  justify-content: space-between;
  padding: 1.3166rem 1.5rem;
  background: white;
}
.controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.558rem;
  height: 2.358rem;
}
.date-selector-detail {
  background: #360ea6;
  margin: 0.5rem;
  border-radius: 0.8rem;
  padding: 0.5rem 0;
  background-image: url(/img/unistars/background_bottom.png);
  background-repeat: no-repeat;
  background-size: 100vw;
  background-position-y: calc(100% - 27rem);
  background-attachment: fixed;
  color: white;
}
.date-selector {
  margin-top: 3.5rem;
  padding-top: 1.2rem;
  height: calc(100vh - 16.7rem);
  margin-bottom: -6rem;
}
.date-selector .btn-area {
  position: absolute;
  width: 100vw;
  bottom: 7rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.date-selector .btn-area .btn-next {
  color: white;
  background: #360ea6;
  height: 2.375rem;
  width: 6.73rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
}
.list-type-selector {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #ededed;
}
.list-type-button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  border-bottom: 2px solid white;
  padding: 0.7rem 0;
}
.list-type-button.active {
  border-bottom: 2px solid #360ea6;
}
.schedule-time-tabs {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.schedule-time-tabs div {
  font-size: 0.95rem;
  font-weight: bold;
  padding: 1.2rem 1rem 0.5rem;
  opacity: 0.5;
  border-bottom: 1px solid white;
}
.schedule-time-tabs div.active {
  border-bottom: 1px solid #360ea6;
  opacity: 1;
}
img.time-icon {
  height: 0.98333333rem;
}
.schedule-detail-setting {
  background: white;
  margin-bottom: 4rem;
}
.product {
  display: flex;
  align-items: center;
  height: 4.6666rem;
  border-bottom: 1px solid #ececec;
  padding: 1rem;
}
.product-image img {
  width: 3.48333rem;
  margin: 0 1rem;
}
.product .dot {
  width: 0.1916rem;
  height: 0.1916rem;
  background: #b2b2b2;
  border-radius: 0.1rem;
}
.product-title {
  font-size: 1rem;
  color: #2c2c2c;
  width: calc(100vw - 12.5rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-intake-co {
  font-size: 0.8333rem;
  display: flex;
  align-items: center;
  justify-content: end;
}
.product-intake-co input {
  border: 1px solid rgba(190, 190, 1990, 0.5);
  width: 2.79rem;
  text-align: center;
  font-size: 0.95rem;
}
.product-intake-co-unit {
  width: 2.5rem;
  padding-left: 0.5rem;
  font-size: 0.8833rem;
}
.detail-schedule-controls.controls {
  justify-content: center;
}
.detail-schedule-controls .btn {
  width: 6.7333rem;
  margin: 0.3rem;
}
.selectors {
  margin-bottom: 0.6rem;
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
}
.selectors > select {
  margin-right: 0.4rem;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.reset-reason-select {
  width: calc(100% - 11.33rem);
  margin-right: 0 !important;
}
.reset-editor-icon {
  width: 0.75rem;
}
.reset-info-label,
.reset-info-input {
  float: left;
}
.reset-info-label {
  width: 6.183rem;
  font-size: 0.95rem;
  color: #360ea6;
  padding: 0 1rem;
  font-weight: bold;
}
.reset-info-row.title-input {
  background: rgba(244, 244, 244, 0.4);
  height: 3.25rem;
}
.reset-info-row.title-input >>> .input-control.simple-design {
  border: none;
}
.reset-info-row.title-input >>> input.form-control {
  width: calc(100% - 1rem);
}
.reset-info-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
}
.reset-info-input {
  width: calc(100% - 5.5rem);
  font-size: 0.95rem;
  padding: 0;
  box-shadow: none;
}
>>> input {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.reset-info-input >>> textarea {
  min-height: 6rem;
}
.reset-info-input >>> input,
.reset-info-input >>> textarea {
  width: 100%;
  border-radius: 0.14166rem;
  border: 1px solid #bebebe;
}
.reset-info-input >>> input {
  padding: 0 0.7333rem;
  height: 2rem !important;
  font-size: 0.8833rem !important;
}
.reset-info-input >>> input::placeholder {
  font-size: 0.8833rem !important;
}
.reset-info-input >>> textarea {
  padding: 0.7333rem;
}
.basis-info-title {
  padding-left: 1rem;
  color: #747474;
  font-size: 0.791666666666667rem !important;
  height: 3.275rem;
  display: flex;
  align-items: center;
  background: rgba(244, 244, 244, 0.4);
}
.alarm-area {
  margin-top: 1rem;
  padding: 0 1rem;
}
.alarm-label {
  width: 9rem;
  height: 2.233333333333333rem;
}
.alarm-input {
  width: calc(100% - 9.5767rem);
  height: 2.233333333333333rem;
}
.reset-alarm {
  display: flex;
  height: 3.625rem;
  font-size: 1rem;
  text-align: center;
  padding: 0.3rem 0.4rem;
  position: relative;
  align-items: center;
}
.reset-alarm >>> input {
  text-align: center;
  font-size: 1rem !important;
  height: 2.233333333333333rem !important;
  line-height: unset;
  padding-top: 0;
  padding-bottom: 0;
  color: #dbdbdb;
  background: transparent;
  border: 1px solid #f4f4f4;
  border-radius: 1.108333333333333rem;
}
.reset-alarm.active >>> input {
  color: black;
}
.reset-alarm >>> input::placeholder {
  font-size: 0.8833rem !important;
  color: #dbdbdb;
}
.reset-alarm >>> .dropdown-menu .btn i,
.reset-alarm >>> .dropdown-menu .btn {
  background: transparent !important;
  width: 3.5rem;
  height: 3.5rem;
  padding: 0 !important;
  margin: 0 !important;
  line-height: 3.5rem;
}
.basis-info-row {
  display: flex;
  align-items: center;
  clear: both;
  font-size: 1rem;
  min-height: 3.275rem;
  padding: 0.6rem 0;
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
}
.basis-info-label {
  display: flex;
  align-items: center;
  font-size: 0.833333333333333rem;
  color: black;
}
.basis-info-label-container {
  display: flex;
  align-items: center;
  height: 2.166666666666667rem;
  border-bottom: 1px solid #f4f4f4;
  width: 100%;
}
.number-label {
  font-size: 0.8rem;
  color: #707070;
}
.basis-info-number {
  float: right;
}
.basis-info-number >>> input.form-control {
  border: none;
  height: 1.4rem !important;
  padding: 0.2rem 0 0 !important;
  margin-bottom: 0.1rem !important;
}
.input-control.simple-design.basis-info-number {
  border: 1px solid #f4f4f4;
  border-radius: 0.766666666666667rem;
  height: 1.858333333333333rem;
  width: 100%;
}
.basis-info-goal .input-control.simple-design.basis-info-number >>> label {
  background: #0a2e65;
}
.input-control.simple-design.basis-info-number >>> .input-group,
.input-control.simple-design.basis-info-number >>> label {
  float: left;
  display: flex;
  align-items: center;
  height: 1.858333333333333rem;
  justify-content: center;
}
.input-control.simple-design.basis-info-number
  >>> .input-group
  input.form-control {
  background: transparent;
}
.input-control.simple-design.basis-info-number >>> label {
  font-size: 0.825rem;
  width: 3.691666666666667rem;
  background: #360ea6;
  color: white;
  border-radius: 0.766666666666667rem;
  margin-bottom: 0;
  margin: -1px;
}
.input-control.simple-design.basis-info-number >>> .input-group {
  width: calc(100% - 3.691666666666667rem);
}

.basis-info-number,
.basis-info-number >>> input {
  width: 3.65rem;
  height: auto;
  line-height: 1.5rem;
  border: none;
  font-size: 0.95rem !important;
  text-align: center;
  color: black;
}
.basis-info-begin,
.basis-info-goal {
  text-align: right;
  width: 7.083333333333333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.875rem;
}
.basis-info-goal {
  margin-bottom: 0.625rem;
}
.basis-info-controls {
  text-align: right;
}
.basis-info-controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.275rem;
  font-size: 0.95rem;
  width: 5.5rem;
  height: 2.483333rem;
  line-height: 0.1rem;
}
.show-sample {
  width: 3.4rem;
  height: 1.541666666666667rem;
  border-radius: 0.566666666666667rem;
  background: #d8d8d8;
  color: white;
  font-size: 0.691666666666667rem;
  text-align: center;
  margin-left: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.basis-info-images-controls {
  display: flex;
  align-items: center;
  justify-content: end;
}
.basis-info-images-controls >>> .file-control,
.basis-info-images-controls >>> .file-preview-slide {
  height: 7.358333333333333rem;
  width: 7.358333333333333rem;
}
.basis-info-images-controls .basis-info-control {
  margin-left: 0.908rem;
  text-align: center;
  position: relative;
}
.begin-images-controls .basis-info-control {
  width: 50%;
  display: flex;
  margin-left: 0;
}
.basis-info-control >>> .upload-guide {
  display: none;
}
.basis-info-control >>> .input-control {
  overflow: hidden;
}
.basis-info-control >>> .no-selected-file {
  background-size: 1.833333333333333rem 2.066666666666667rem;
  background-color: #e7edf5;
  border: none !important;
  border-radius: 0.5rem;
  background-position: 50%;
}
.basis-info-control >>> .form-control {
  border: none;
}
.partner-search-keyword {
  margin-left: 1.2rem;
  border-radius: 1.108333333333333rem;
  border: 1px solid #c5c5c5;
  width: 17.625rem;
  height: 2.25rem;
  margin-right: 1rem;
  font-size: 1rem;
  color: black;
  text-align: center;
}
.partner-search-keyword.full {
  width: 100%;
  margin-left: 0;
}
.partner-search-keyword {
  font-size: 0.8333rem;
  padding: 0 0.5rem;
}
.partner-search-keyword::placeholder {
  font-size: 0.8333rem !important;
  color: rgba(0, 0, 0, 0.1);
}
.partner-search-button {
  margin-left: 0.6rem;
  font-size: 0.666rem;
  color: white;
  background: #360ea6;
  width: 3.458rem;
  height: 2.308rem;
}
.partner-search-button:active,
.partner-search-button:focus,
.partner-search-button:hover {
  color: white;
}
>>> .input-group .form-control {
  z-index: 1;
}
.basis-info-row-search-partner {
  justify-content: space-between;
}
.basis-info-row.basis-info-row-search-partner .dot {
  background: #360ea6;
  opacity: 1;
}
.basis-info-row.basis-info-row-search-partner .basis-info-title {
  font-size: 1rem !important;
  color: black;
  font-weight: normal;
  background: white;
}
.searched-partner-list-wrapper {
  display: flex;
}
.searched-partner-list-wrapper .partner-item {
  width: calc(100% / 3);
  min-width: calc(100% / 3);
}
.searched-partner-list-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
  word-break: break-all;
  padding: 0 1rem;
  margin: 1rem 0;
}
.searched-partner-list-container.no-data {
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-control-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.searched-partner-list-container .partner-image {
  overflow: hidden;
  border-radius: 2.6rem;
  width: 5.2rem;
  height: 5.2rem;
  background: #ededed;
}
.searched-partner-list-container .partner-item {
  margin: 0 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
}
>>> .month-day .date {
  color: black;
}
>>> .month-day.disabled .date {
  color: #d8d8d8;
}
>>> .start-date .date,
>>> .end-date .date,
>>> .start-date-selected .date,
>>> .end-date-selected .date,
>>> .clicked .date {
  color: white;
}
.searched-partner-list-container .partner-name,
.searched-partner-list-container .partner-grade,
.searched-partner-list-container .partner-tel {
  font-size: 0.8833rem;
  color: #363636;
  text-align: center;
}
.searched-partner-list-container .btn-select-partner {
  background: #dbdbdb;
  color: white;
  height: auto;
  padding: 0.5rem 0;
  width: 5.5rem;
  margin-top: 0.1rem;
  font-size: 0.8833rem;
  line-height: 0.5rem;
}
.resets-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: calc(100% / 3);
}
.basis-info-row.header-row {
  margin-top: -2rem;
}
.basis-info-row.header-row .basis-info-label {
  width: calc(100% - 11rem);
}
.basis-info-controls .btn-inbody-upload {
  background: transparent;
  color: #360ea6;
  font-weight: bolder;
  font-size: 1.8rem;
  padding: 0 1rem;
}
.reset-editor-icon.inbody {
  width: 1.166666666666667rem;
}
.inbody-image-row.basis-info-row {
  border-bottom: none;
  padding: 0;
}
.inbody-image-row {
  background: rgba(244, 244, 244, 0.4);
  height: 2.233333333333333rem;
  margin: 0 0.625rem 1rem;
}
.inbody-image-row .basis-info-title {
  background: transparent;
}
.inbody-result-row {
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
  font-size: 0.8833rem;
  text-align: center;
}
.inbody-result-row.has-contents {
  padding-bottom: 1rem;
}
.inbody-image-row {
  height: 2.166666666666667rem;
  min-height: unset;
}
.inbody-image-control {
  height: 2.166666666666667rem;
}
.inbody-image-control.basis-info-images-controls >>> .file-control,
.inbody-image-control.basis-info-images-controls >>> .file-preview-slide {
  height: 1.5rem;
  width: 1.5rem;
}
.inbody-image {
  width: 80vw;
  position: absolute;
  left: -80vw;
  z-index: 12;
  bottom: 0;
}
.inbody-image >>> img {
  width: 100%;
  border: 1px solid #cccccc;
}
.sample-image {
  position: fixed;
  z-index: 1099;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.basis-info-2-container {
  display: flex;
  overflow: auto;
  width: 100vw;
  padding-bottom: 1rem;
}
.basis-info-2-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

.basis-info-2-container .basis-info-row {
  width: calc(100vw / 3 - 1.1rem);
  min-width: calc(100vw / 3 - 1.1rem);
  margin-left: 0.65rem;
  margin-top: 0.775rem;
  display: flex;
  padding: 0 0.5rem;
  flex-direction: column;
  border: 1px solid #f4f4f4;
  border-radius: 0.208333333333333rem;
}
.begin-image-row {
  border: 1px solid rgba(153, 153, 153, 0.4);
  border-radius: 0.5rem;
  margin: 0.65rem;
  padding: 1rem;
}
.basis-info-row .dot,
.begin-image-title .dot {
  width: 0.5rem;
  height: 0.5rem;
  background: #360ea6;
  opacity: 0.2;
  border-radius: 50%;
  margin: 0 0.5rem;
}
.begin-image-title .basis-info-label {
  width: calc(100% - 1.5rem);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.begin-image-title .basis-info-label .show-sample {
  float: right;
}
.begin-image-title {
  display: flex;
  border-bottom: 1px solid rgba(153, 153, 153, 0.4);
  height: 1.541666666666667rem;
  align-items: center;
  padding-bottom: 0.541666666666667rem;
  margin-bottom: 1rem;
}
.basis-info-control-name-and-button {
  padding: 0 0.816666666666667rem;
}

.basis-info-control-name-and-button .basis-info-control-name {
  font-size: 0.6666rem;
  color: #0a2e65;
}
.basis-info-control-name-and-button .upload-btn {
  background: #d8d8d8;
  border-radius: 0.566666666666667rem;
  color: white;
  font-size: 0.716666666666667rem;
  width: 3.233333333333333rem;
  height: 1.608333333333333rem;
  margin-top: 0.608333333333333rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
